<template>
<div class="netflix">
    
<Banner />
 

 <Header />

<div class="shadow"></div>

<div class="homepage">
 
  <Netflixorigional />

  <Netflixtrending />
   
   <Toprated />
 
   <Genre />

   <Newrelease />
 
   <Footer />
 </div>
</div>

</template>

<script>
import axios from 'axios'
import lazyload from '../directives/lazyload'
import Header from './Header'
import Banner from './Banner'
import Netflixtrending from './Netflixtrending'
import Toprated from './Toprated'
import Genre from './Genre'
import Newrelease from './Newrelease'
import Netflixorigional from './Netflixorigional'
import Footer from './Footer'


//baseurl = "https://image.tmdb.org/t/p/original/";
export default {
    name:"",
    
    components:{
        Header,
        Banner,
      Netflixorigional,
      Netflixtrending,
      Toprated,
      Genre,
      Newrelease,
      Netflixorigional,
      Footer
    },
    data(){
        
        return{
            
           
        }
    },
    
    methods: {

    },
    directives:{
      lazyload
    },
    mounted() {
        
            
          var mulanlogo = document.querySelector('.mulanlogo');
           
            document.addEventListener("DOMContentLoaded",function(){
                
                setTimeout(()=>{
                 mulanlogo.classList.add("hidemulanlogo");
                  },10000) ; 
               
               
            },{once:true});
                 
    },
    created() {        

    },
   
   }
    window.addEventListener("scroll", function() {
    let header = document.querySelector('.netflix-header');
    let windowPosition = window.scrollY > 0;
    header.classList.toggle('scroll-active', windowPosition);
   
     })
      
  
  
  window.addEventListener("scroll", function(event) {
  var video = document.querySelector(".main-video video");
    var top = this.scrollY;
 
       if(top > 700){
           video.pause();
       }
       else{
           video.play();
       }
            }, false);
    
    
    
   
       
</script>

<style scoped>

.netflix{
    width:100%;
}


.homepage{
    position: absolute;
    width: calc(100%);
    padding-left: 2.5vw;
    float: right;
    z-index: 1000;
    margin-top: -2.5vw;
    box-sizing: border-box;
}
  
</style>        